import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { setCORS } from 'google-translate-api-browser';

import { ReduxState } from 'redux/root-reducer';

import { TranslationResult, TranslateParams, ChangeLanguageParams } from './types';

const translateWithProxy = setCORS('https://cors-proxy.interpals.net/');

function translate(
    text: string,
    opts?: {
        from?: string;
        to?: string;
        raw?: boolean;
    },
): Promise<TranslateResponse> {
    return translateWithProxy(text, opts) as Promise<TranslateResponse>;
}

interface TranslateResponse {
    text: string;
    from: {
        language: {
            iso: string;
        };
    };
}

export const translateMessage = createAsyncThunk<TranslationResult, TranslateParams, { state: ReduxState }>(
    'translations/translate',
    async (params: TranslateParams, { getState }) => {
        const { id, text, currentLanguage } = params;

        const { account } = getState();
        const { targetLanguage } = getState().translations;

        const fromLanguage = currentLanguage ?? 'auto';
        const toLanguage = targetLanguage ? targetLanguage : account.data?.lang.slice(0, 2);

        return await translate(text, {
            from: fromLanguage,
            to: toLanguage,
        }).then((response) => ({
            id,
            originalText: text,
            translation: response.text,
            currentLanguage: currentLanguage ?? response.from.language.iso,
            targetLanguage: toLanguage,
        }));
    },
);

export const hideTranslationById = createAction<string>('translations/hide-by-id');
export const changeLanguage = createAction<ChangeLanguageParams>('translations/change-language');
